// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"67":"a3796ad489ea6df3","888":"574e2642bf588e3f"}[chunkId] + ".css";
};